/**
 * Created by neo on 17.04.22.
 */
import { makeAutoObservable } from 'mobx';
import { LocalizedValue, createLocalizedValue } from '../LocalizedValue';
import { languagePriority } from '../LocalizedNamedEntity';

export type Quote = {
  tags: string[];
  values: LocalizedValue[];
  readonly defaultQuote: string;
  getQuote(lang: string): string;
};

export function createQuote(json?: Partial<Quote>): Quote {
  return makeAutoObservable({
    tags: json?.tags ?? [],
    values: (json?.values ?? []).map((v: any) => createLocalizedValue(v)),

    get defaultQuote(): string {
      for (const lang of languagePriority) {
        const entry = this.values.find((l) => l.lang === lang);
        if (entry) {
          return entry.value ?? '';
        }
      }
      return this.values[0]?.value ?? '';
    },

    getQuote(lang: string): string {
      return this.values.find((n) => n.lang === lang.toLowerCase())?.value || this.defaultQuote;
    },
  });
}
